const INK = '#1F1C1C';
const DARK_INK = '#F5F0ED';

export type ParsedStreamlineSvg = {
  viewBox: string;
  inner: string;
};

/** Strip the document wrapper; keep native Streamline geometry. */
export function parseStreamlineSvg(raw: string): ParsedStreamlineSvg {
  const viewBoxMatch = raw.match(/\bviewBox="([^"]+)"/i);
  const viewBox = viewBoxMatch?.[1] ?? '0 0 14 14';
  const inner = raw
    .replace(/<\?xml[^>]*>/gi, '')
    .replace(/<!DOCTYPE[^>]*>/gi, '')
    .replace(/<svg[^>]*>/i, '')
    .replace(/<\/svg>\s*$/i, '')
    .replace(/<desc>[\s\S]*?<\/desc>/gi, '')
    .trim();
  return { viewBox, inner };
}

/**
 * Line and Solid icons use a single ink color on small controls. Duo/Flat keep
 * their exported brand palette from assets/streamline/sources.json.
 */
export function toneStreamlineSvg(
  raw: string,
  mode: 'mono' | 'preserve',
  dark = false,
): ParsedStreamlineSvg {
  const parsed = parseStreamlineSvg(raw);
  if (mode === 'preserve') return parsed;
  const ink = dark ? DARK_INK : INK;
  const inner = parsed.inner
    .replaceAll(INK, 'currentColor')
    .replaceAll(ink, 'currentColor')
    .replaceAll(DARK_INK, 'currentColor');
  return { ...parsed, inner };
}

export function illustrationDimensions(viewBox: string) {
  const parts = viewBox.split(/\s+/).map(Number);
  if (parts.length === 4 && parts.every((n) => Number.isFinite(n))) {
    return { width: parts[2], height: parts[3] };
  }
  return { width: 200, height: 200 };
}
